<div class="phone_btn out_call" [ngClass]="{round:round}" [style.background]="'#40BE5C'">
  <img class="phone call" [ngClass]="{small:round}" src="assets/images/phone_white.svg">
</div>